import $ from "jquery";

//スクロールでメニューバーにクラス付与
const scrollEffect = document.querySelector(".js-scroll");
function scrollAddClass() {
  let scrollY = window.scrollY;
  if (60 < scrollY) {
    scrollEffect.classList.add("is-active");
  } else {
    scrollEffect.classList.remove("is-active");
  }
}
document.addEventListener("scroll", scrollAddClass);

$(function () {
  //PCメニューのアコーディオン;
  $(".js-menu-button").on("mouseenter", function () {
    const targetHeight = $(".js-submenu-list").outerHeight();
    $(".js-submenu").height(targetHeight);
    $(".js-submenu").addClass("is-hover");
  });
  $(".js-scroll").on("mouseleave", function () {
    $(".js-submenu").height(0);
    $(".js-submenu").removeClass("is-hover");
  });
  //SPメニューのアコーディオン;
  $(".js-menu-sp").on("touchstart", function () {
    if ($(".l-hamburger-submenu").hasClass("is-hover")) {
      $(".l-hamburger-submenu").height(0);
      $(".l-hamburger-submenu").removeClass("is-hover");
    } else {
      const targetHeight = $(".js-menu-sp-list").outerHeight();
      $(".l-hamburger-submenu").height(targetHeight);
      $(".l-hamburger-submenu").addClass("is-hover");
    }
  });
});
